import { Component, EventEmitter, Output } from '@angular/core';
import { AppService } from '../../services/app.service';
import { DATOS_DEMO } from '../datos-demo';

interface ItemMenu {
  texto : string;
  ruta : string;
  /** Pendiente: la pantalla del prototipo todavia no existe. */
  pendiente? : boolean;
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

  /** En mobile es un drawer: al navegar hay que cerrarlo. */
  @Output() navegar = new EventEmitter<void>();

  /** Cerrar sesion: lo maneja el shell (app.component), igual que el tabbar. */
  @Output() cerrarSesion = new EventEmitter<void>();

  // "Mis compras" se reemplazo por "Historial de puntos" en su lugar (cada linea
  // del historial va a llevar a su compra). "Que queres recibir" se oculta del
  // menu; la pantalla /preferencias sigue existiendo, sin acceso desde el menu.
  items : ItemMenu[] = [
    { texto: 'Resumen',            ruta: '/home' },
    { texto: 'Mis mascotas',       ruta: '/mis-mascotas' },
    { texto: 'Historial de puntos', ruta: '/historial-puntos' },
    { texto: 'Mis beneficios',     ruta: '/mis-beneficios' },
    { texto: 'Mis datos',          ruta: '/edit-customer' },
    { texto: 'Mis domicilios',     ruta: '/customer-adress-list' }
  ];

  // Ver datos-demo.ts: no hay fecha de alta del socio en ninguna API.
  socioDesde = DATOS_DEMO.socioDesde;

  constructor(public appService : AppService) {}
}
